import { createSelector } from 'reselect'
import { createSelector as ormSelector } from 'redux-orm'
import { createFilteredEntitiesSelector } from "selectors/entities";
import getEntities from 'selectors/entities'
import orm from 'models'
import { getKeyWindowSelector } from 'selectors/key_windows'

import _ from 'lodash'

export const getInvoices = ormSelector(orm, getEntities, (session) => {
  return session.invoice.all().toModelArray().map(invoice => {
    const { ref } = invoice
    let dossier = session.dossier.withId(invoice.dossierId)
    let patient = null;

    let dossierHash = {};

    if (dossier) {
      patient = session.contact.withId(dossier.patientId)
      dossierHash = {
        ...dossier.ref,
        responsibles: dossier.responsibleIds?.map(id => session.employment.withId (id)),
        patient: patient ? patient.ref : null
      }
    }

    return { ...ref,
      dossier: dossierHash,
      patient: patient ? patient.ref : null,
      emailCommunications: invoice.emailCommunications?.toRefArray(),
      invoiceItems: session.invoiceItem.filter(item => item.invoiceId === invoice.id).toRefArray()
    }
  })
})

export const getSortedInvoicesForMenu = createSelector([getInvoices],
  (invoices) => { return ( _.reverse(_.sortBy(invoices, [i => !i.proposed, 'concept', 'formattedIdentification', (invoice) => invoice.patient?.lastName ] )).filter(i=> i.proposed || i.concept))
})

export const getSortedInvoices = createSelector([getInvoices],
  (invoices) => { return ( _.reverse(_.sortBy(invoices, [i => !i.proposed, 'concept','formattedIdentification', (invoice) => invoice.patient?.lastName ] )))
})
export const getFilteredSortedInvoices = createFilteredEntitiesSelector(getSortedInvoices,'invoice')

export const getInvoicesForDossier = createSelector([getKeyWindowSelector('invoice', 'dossier', getInvoices)], (invoices) => { return ( _.reverse(_.sortBy(invoices, ['formattedIdentification', (invoice) => invoice.patient?.lastName ] )))
})

